import React from 'react';
import { LaunchOutlinedIcon } from 'tuui';
import { INDICATION_TYPES } from 'taboola-ultimate-ui';
import { AddConversion } from 'modules/campaigns/modules/common-campaign-form/components/AddConversionButton/AddConversionButton';
import { AddTrackingButton } from 'modules/campaigns/modules/common-campaign-form/components/AddTrackingButton/AddTrackingButton';
import { MARKETING_OBJECTIVE_KEYS } from 'modules/campaigns/modules/common-campaign-form/config';
import CONVERSION_RULE_MODES from 'modules/campaigns/modules/common-campaign-form/config/ConversionRuleModes';

export const conversionRulesModeValidations = [
    {
        validationFn: (value, options, { isPixelOrS2sInstalled, isPixelWarningPermitted, marketingObjective }) => {
            if (!isPixelWarningPermitted) {
                return true;
            }
            if (
                value === CONVERSION_RULE_MODES.CUSTOM &&
                (marketingObjective === MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL)
            ) {
                return isPixelOrS2sInstalled;
            }
            return true;
        },
        messageId: 'campaign.editor.conversion.goal.conversion.noPixelImplementation',
        messageValues: {
            tracking: <AddTrackingButton />,
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (value, options, { isPixelOrS2sInstalled, isPixelWarningPermitted, marketingObjective }) => {
            if (!isPixelWarningPermitted) {
                return true;
            }

            if (
                value === CONVERSION_RULE_MODES.CUSTOM &&
                (marketingObjective === MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC)
            ) {
                return isPixelOrS2sInstalled;
            }
            return true;
        },
        messageId: 'campaign.editor.conversion.goal.conversion.worksBestWithPixel',
        messageValues: {
            tracking: <AddTrackingButton />,
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (
            value,
            options,
            { hasAtLeastOneActiveConversion, isPixelWarningPermitted, marketingObjective }
        ) => {
            if (!isPixelWarningPermitted) {
                return true;
            }
            if (
                value === CONVERSION_RULE_MODES.CUSTOM &&
                (marketingObjective === MARKETING_OBJECTIVE_KEYS.LEADS_GENERATION ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.ONLINE_PURCHASES ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.MOBILE_APP_INSTALL)
            ) {
                return hasAtLeastOneActiveConversion;
            }
            return true;
        },
        messageId: 'campaign.editor.conversion.goal.conversion.noConversions',
        messageValues: {
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
    {
        validationFn: (
            value,
            options,
            { hasAtLeastOneActiveConversion, isPixelWarningPermitted, marketingObjective }
        ) => {
            if (!isPixelWarningPermitted) {
                return true;
            }
            if (
                value === CONVERSION_RULE_MODES.CUSTOM &&
                (marketingObjective === MARKETING_OBJECTIVE_KEYS.BRAND_AWARENESS ||
                    marketingObjective === MARKETING_OBJECTIVE_KEYS.DRIVE_WEBSITE_TRAFFIC)
            ) {
                return hasAtLeastOneActiveConversion;
            }
            return true;
        },
        messageId: 'campaign.editor.conversion.goal.conversion.worksBestWithActiveConversion',
        messageValues: {
            conversion: <AddConversion id="campaign.editor.conversion.goal.conversion" defaultMessage="Conversion" />,
            linkIcon: <LaunchOutlinedIcon />,
        },
        severity: INDICATION_TYPES.WARNING,
    },
];
